/** Lowercase without accents, so « Créer » and « creer » compare equal. */
export const foldText = (text: string): string => text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
